var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "itinerary-selection__header" }, [
    _c("h1", { staticClass: "itinerary-selection__title" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.tc("spaSoft.step1.itinerarySelection.title")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "itinerary-selection__subtitle" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.tc("spaSoft.step1.itinerarySelection.subtitle"))),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "itinerary-selection__edit-cta",
          on: { click: _vm.editSelectedTreatments },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.tc(
                  "spaSoft.step1.itinerarySelection.editSelectedTreatmentsCTA"
                )
              ) +
              "\n    "
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }